import type { Parameters } from '@atlaskit/editor-common/extensions/extension-parameters';
import DefaultExtensionProvider from '@atlaskit/editor-common/extensions/default-extension-provider';

import { createChartsExtension } from '@confluence/charts/entry-points/createChartsExtension.ts';

import { getConnectionsToolbarItem } from './referentiality-extension-provider.tsx';
import { fireAnalyticsEventForConnectionsButton } from './toolbar-analytics.ts';

export const connectChartExtensionProvider = async (
	intl: any,
	editorActions: any,
	openConnectionsPanel: any,
	createAnalyticsEvent: any,
): Promise<DefaultExtensionProvider<Parameters>> => {
	return new DefaultExtensionProvider([
		await createChartsExtension({
			intl,
			editorActions,
			createAnalyticsEvent,
			externalToolbarItems: openConnectionsPanel
				? [
						getConnectionsToolbarItem({
							intl,
							openConnectionsPanel,
							fireAnalytics: (adf) =>
								fireAnalyticsEventForConnectionsButton(createAnalyticsEvent, adf),
						}),
					]
				: [],
		}),
	]);
};
